/**
 * Created by ray on 2017/12/16.
 */

import { Injectable } from '@angular/core';
import {BaseGuard} from "./base.guard";


@Injectable()
export class DellGuard extends BaseGuard{
  permissionName = this.constants.dell_module_permission;
}



// WEBPACK FOOTER //
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/shared/guards/dell.guard.ts